import * as React from 'react';

import styled from 'styled-components';

import { BannerAnnouncement } from './Banner';
import { Container } from './Container';

const Wrapper = styled.div`
  border: 1px solid #333;
  padding: 20px;
  background: rgb(0, 0, 40, 3%);
`;

const CardGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
`;

const CardRow = styled.div`
  display: flex;
  gap: 20px;
`;

const Card = styled.a`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 30px 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background: #fff;
  text-decoration: none;
  color: #333;
  font-size: 16px;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border-color: #0052cc;
    color: #0052cc;
  }
`;

const Emoji = styled.span`
  font-size: 40px;
  margin-bottom: 12px;
`;

const baseUrl = () => window.location.origin;

export const SsrNavigator = (): JSX.Element => (
  <Container>
    <BannerAnnouncement />
    <br />
    <Wrapper>
      <h2>🎂 Baked Cakes: Our Server-Side Rendered Pages</h2>
      <p>Select an SSR experience below to try it out:</p>
      <CardGrid>
        <CardRow>
          <Card href={`${baseUrl()}/ssr/async-init`}>
            <Emoji>🚀</Emoji>
            Async Init
          </Card>
          <Card href={`${baseUrl()}/ssr/proxy`}>
            <Emoji>🔁</Emoji>
            Atlassian Proxy
          </Card>
        </CardRow>
        <CardRow>
          <Card href={`${baseUrl()}/ssr/auth-headers`}>
            <Emoji>🔐</Emoji>
            Auth Headers
          </Card>
          <Card href={`${baseUrl()}/ssr/bad-bundle`}>
            <Emoji>💔</Emoji>
            Test Broken Bundle
          </Card>
        </CardRow>
        <CardRow>
          <Card href={`${baseUrl()}/ssr/base-url`}>
            <Emoji>🔗</Emoji>
            Base URL
          </Card>
          <Card href={`${baseUrl()}/ssr/feature-gate`}>
            <Emoji>🚩</Emoji>
            Feature Gate
          </Card>
        </CardRow>
        <CardRow>
          <Card href={`${baseUrl()}/ssr/fetch`}>
            <Emoji>🌐</Emoji>
            Simple Fetch
          </Card>
          <Card href={`${baseUrl()}/ssr/flakey`}>
            <Emoji>🎲</Emoji>
            Flakey SSR Test
          </Card>
        </CardRow>
        <CardRow>
          <Card href={`${baseUrl()}/ssr/graphql-gateway`}>
            <Emoji>🔀</Emoji>
            GraphQL Gateway Test
          </Card>
          <Card href={`${baseUrl()}/ssr/kv`}>
            <Emoji>🗄️</Emoji>
            KV API
          </Card>
        </CardRow>
        <CardRow>
          <Card href={`${baseUrl()}/ssr/load?amount=5&time=1000`}>
            <Emoji>🚦</Emoji>
            Load Shedding
          </Card>
          <Card href={`${baseUrl()}/ssr/service-to-service`}>
            <Emoji>📱🔄📱</Emoji>
            Service-to-Service Test
          </Card>
        </CardRow>
        <CardRow>
          <Card href={`${baseUrl()}/ssr/ssr-context`}>
            <Emoji>🔍</Emoji>
            SSR Context
          </Card>
          <Card href={`${baseUrl()}/ssr/hello_ssr_world`}>
            <Emoji>👋</Emoji>
            Hello SSR World
          </Card>
        </CardRow>
        <CardRow>
          <Card href={`${baseUrl()}/ssr/stargate`}>
            <Emoji>⭐⛩️</Emoji>
            Stargate Test
          </Card>
          <Card href={`${baseUrl()}/ssr/window-location`}>
            <Emoji>📍</Emoji>
            Window Location
          </Card>
        </CardRow>
      </CardGrid>
    </Wrapper>
  </Container>
);
